import { CanActivateFn, Router } from '@angular/router';
import { WorkflowService } from '../services/workflow.service';
import { inject } from '@angular/core';

export const prescriptionDetailsGuard: CanActivateFn = () => {
  const currentRoute = inject(WorkflowService).currentRoute;

  return currentRoute === 'prescription' ? true : inject(Router).navigate(['/']);
};
